import { createContext } from 'react';

export const userContext = createContext({
  isLoggedIn: false,
  userId: null,
  token: null,
  userType:null,
  login: () => {},
  logout: () => {}
});
